export default __webpack_public_path__ + "static/media/paper18.06a4f4f4.JPG";